import { useSnackbar } from 'notistack';
import Form, { FormProps } from '..';
import useStore from '../../Hooks/useStore';
import './Recover.css';
import { useState } from 'react';

interface FormRecoverPasswordRequestProps extends FormProps {}

export default function FormRecoverPasswordRequest({
  children,
  className = '',
  ...rest
}: FormRecoverPasswordRequestProps) {
  const [getters, setters] = useStore();
  const { enqueueSnackbar } = useSnackbar();
  const {
    form: { getForm, getRecoverFormMessage },
  } = getters;

  const {
    form: {
      setForm,
      blurRecoverForm,
      getRecoverFormValidation,
      resetRecoverForm,
    },
    user: { recoverPassword },
    modal: { closeSingleModal },
  } = setters;
  const [loading, setLoading] = useState(false);

  const onSubmit = (e: any) => {
    e.preventDefault();
    if (getRecoverFormValidation(['email'])) {
      setLoading(true);
      recoverPassword()
        .then(() => {
          setLoading(false);
          closeSingleModal('recoverPassword');
          resetRecoverForm();
          enqueueSnackbar('Foi enviado um email de recuperação para você', {
            variant: 'success',
          });
        })
        .catch((error) => {
          setLoading(false);
          enqueueSnackbar(error.message, {
            variant: 'error',
          });
        });
    }
  };

  return (
    <Form
      className="form-recover-request"
      onSubmit={onSubmit}
      style={{
        marginTop: '2rem',
      }}
      {...rest}
    >
      <Form.Input
        label="Email"
        value={getForm('recoverPassword.email')}
        onBlur={() => blurRecoverForm('email')}
        error={getRecoverFormMessage().email['0']}
        onChange={(e) => {
          setForm('recoverPassword.email', e.target.value);
        }}
      />
      <Form.Button type="submit" loading={loading} disabled={loading}>
        Enviar
      </Form.Button>
    </Form>
  );
}
